import {MenuContentCmp as MenuContent, MenuLinkCmp as MenuLink} from '../../components/MenuCmp';
import UIControls from '../../components/UIControlsCmp';
import VersionCmp from '../../components/VersionCmp';
import Urls from '../../constants/urls';
import {rooms} from './data';

const REMenu = () => {
  return (
    <>
      <MenuContent>
        {rooms.map(room => (
          <MenuLink key={room.name} to={room.route.path}>
            {room.name}
          </MenuLink>
        ))}
        <VersionCmp />
      </MenuContent> 
      <UIControls homeUrl={Urls.realEstate.outdoorView.path} />
    </>
  );
}

export default REMenu;
